import { AuxButtonSizeEnum, AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { replace } from "connected-react-router";
import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import { InsDownloadEmptyTemplate } from "../empty-templates/insDownloadEmptyTemplate";
import { InsPublicEquityIndicesExport } from "./insPublicEquityIndicesExport";
import { InsPublicEquityIndicesUpload } from "./insPublicEquityIndicesUpload";
import { useGetPmis, EmptyTemplateType } from "api/admin/src";
import { InsGrid } from "components";
import { MessagesDialogFunctionName } from "components/frame/helper";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { language } from "language/default";
import { setSelectedRowsState } from "store/grids";
import { setMessagesDialog } from "store/messages-dialog";
const cols = [
    { colId: "name", field: "name", headerName: "Index Name", type: [CustomColumnType.InsLinkColumn] },
    { colId: "ticker", enableRowGroup: true, field: "ticker", headerName: "Index Ticker", type: CustomColumnType.AUX_TEXT_COLUMN },
    { colId: "currency", enableRowGroup: true, field: "currency", headerName: "Currency", type: CustomColumnType.AUX_TEXT_COLUMN }
];
const customCols = [
    ...cols,
    { colId: "id", field: "benchmarkId", hide: true, type: CustomColumnType.AUX_TEXT_COLUMN },
    {
        colId: "delete",
        field: "deleteIcon",
        filter: false,
        headerName: language.en.common.delete,
        type: [CustomColumnType.AUX_BUTTON_COLUMN, CustomColumnType.InsCenterAllignedColumn],
        width: 100
    }
];
const templateFileName = "IndexPriceHistoryTemplate.xlsx";
const indicesLang = language.en.administration.marketDataAdministration.indices;
export const publicEquityIndicesGridState = "public-equity-indices-grid";
export const InsPublicEquityIndicesContent = (props) => {
    const dispatch = useDispatch(), [pmis, queryState, forceRequestCallback] = useGetPmis();
    const rows = useMemo(() => {
        const data = pmis?.filter((x) => x && (props.isCustom ? x.customId : !x.customId)).map((x) => ({ ...x, ticker: props.isCustom ? x.customId : x.benchmarkId }));
        return data.map((row) => {
            const custom = props.isCustom
                ? {
                    deleteIcon: {
                        icon: "delete",
                        onClick: () => {
                            dispatch(setMessagesDialog({
                                customProp: row,
                                functionName: MessagesDialogFunctionName.PublicEquityIndicesContent,
                                messages: [{ message: indicesLang.deleteConfirmationMessage }],
                                title: indicesLang.deleteHeader,
                                type: "alert-with-options"
                            }));
                        },
                        size: AuxButtonSizeEnum.SMALL,
                        type: AuxButtonTypeEnum.TERTIARY_SUBTLE
                    },
                    name: { label: row?.name,
                        onClick: () => {
                            dispatch(setSelectedRowsState({ id: publicEquityIndicesGridState, selectedRows: [row.benchmarkId ?? ""] }));
                            dispatch(replace(`/administration/market-data/public-equity-indices/${row.benchmarkId}`));
                        } }
                }
                : { name: row?.name };
            return { ...row, ...custom };
        });
    }, [pmis, props.isCustom, dispatch]);
    return React.createElement(React.Fragment, null,
        props.isCustom === true && React.createElement("div", { className: "tabHeaderRight" },
            React.createElement(InsDownloadEmptyTemplate, { fileName: templateFileName, templateType: EmptyTemplateType.Indices }),
            React.createElement(InsPublicEquityIndicesExport, null),
            React.createElement(InsPublicEquityIndicesUpload, { callback: forceRequestCallback })),
        React.createElement("div", { className: "defaultIndicesGrid" },
            React.createElement(InsGrid, { stateId: publicEquityIndicesGridState, columnDefs: props.isCustom ? customCols : cols, rowData: rows, selectionMode: "multiple", queryState: queryState, rowSelectedHandler: ((e) => {
                    if (props.isCustom === true) {
                        const selected = e.api.getSelectedRows();
                        dispatch(setSelectedRowsState({ id: publicEquityIndicesGridState, selectedRows: selected?.map((d) => d?.benchmarkId?.toString()) || [] }));
                    }
                }) })));
};
